// LIVE DATABASE
export const BASE_URL = 'https://www.partsklik24.com';
export const WS_URL = 'wss://www.partsklik24.com';

// Local Database
// export const BASE_URL = 'http://192.168.1.42:8000';
// export const WS_URL = 'ws://192.168.1.42:8006';

// VPS IP
// export const BASE_URL = 'http://194.238.17.78:8000';
// export const WS_URL = 'ws://194.238.17.78:8006';

const PREFIX_URL = `${BASE_URL}/api/admin-panel`;
export const MEDIA_URL = `${BASE_URL}`;
// export const MEDIA_URL = `${BASE_URL}/media/`;

// API KEY
export const APIKEY = "web.XYnghkojkngYtklvbWqloj98687.partsklik";


export const GET_ORDER_BY_ID = `${PREFIX_URL}/get-order-detail/`;